import { createListenerMiddleware } from '@reduxjs/toolkit';
import { missionV2Api } from 'services/missionV2';
import { vehiclesV2Api } from 'services/vehiclesV2';
import { clearSelectedVehicle, setSelectedVehicle } from 'store/slices/appSlice';

import { store } from '.';

export const listenerMiddleware = createListenerMiddleware();

listenerMiddleware.startListening({
    actionCreator: clearSelectedVehicle,
    effect: async (_, listenerApi) => {
        listenerApi.dispatch(missionV2Api.util.resetApiState());
    },
});

listenerMiddleware.startListening({
    actionCreator: setSelectedVehicle,
    effect: async (action, listenerApi) => {
        const selectedVIN = action.payload.selectedVIN;

        // Look up the selected vehicle from the by-VIN V2 cache (getVehicleByVINV2)
        const vehicle = selectedVIN
            ? vehiclesV2Api.endpoints.getVehicleByVINV2.select(selectedVIN)(store.getState()).data
            : undefined;

        if (vehicle) {
            // Check if there is a mission assigned to the selected vehicle
            const hasMission = !!vehicle.activeMissionId?.value?.data;

            if (!hasMission) {
                // if the currently selected vehicle (or deselected) does not have a mission
                // reset the missionAPI state, so cache entries are removed an missionAPI unsubscribes (closes) from the websocket
                listenerApi.dispatch(missionV2Api.util.resetApiState());
            }
        }
    },
});
